import { css, useTheme } from '@fable/theme'
import { Text } from '@fable/components'

const SearchResultsFooterBook = () => {
  const { colors } = useTheme()

  return (
    <div
      className={css`
        width: 100%;
        text-align: center;
      `}
    >
      <a
        href="https://forms.gle/48WNAbTdZyDzoz4i8"
        target="_blank"
        rel="noreferrer"
      >
        <Text
          type="body"
          sizing="M"
          text="Can't find the book you're looking for?"
          color={colors.uiPewterGrey}
        />
        <Text
          type="body"
          sizing="M"
          color={colors.uiBlueLight}
          text="Request to have it added to Fable."
        />
      </a>
    </div>
  )
}

export default SearchResultsFooterBook
